// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.install-page {
    display: flex;
    height: 100vh;
    background:white;
    overflow: hidden;
    font-family: 'Segoe UI', sans-serif;
    color: white;
    position: relative;
  }
  
  .canvas-side {
    width: 0%;
    height: 100%;
  }
  .submit {
    background: black;
  }

  
  .install-container {
      left: calc(50% - 200px);
      color: black;
      padding: 40px;
      padding-left:30px;
      padding-right:30px;
      width: min(100vw,600px);
      height: 100%;
      z-index: 9999;
      margin: auto;
      background: rgba(0, 0, 0, 0.1);
      backdrop-filter: blur(80px);
      border-radius: 20px;
      box-shadow: 0 0 20px black;
      text-align: center;
      display:flex;
      flex-direction: column;
      gap: 0px;
    }
  @media screen and (min-width: 600px) {
    .install-container {
      left: calc(50% - 200px);
      color: black;
      padding: 40px;
      padding-left:30px;
      padding-right:30px;
      width: min(100vw,600px);
      height: 350px;
      z-index: 9999;
      margin: auto;
      background: rgba(0, 0, 0, 0.1);
      backdrop-filter: blur(80px);
      border-radius: 20px;
      box-shadow: 0 0 20px black;
      text-align: center;
      display:flex;
      flex-direction: column;
      gap: 0px;
    }
  }
  .install-container h2 {
    margin-bottom: 30px;
  }
  
  .install-container form {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
h3,pre {
  margin-bottom:0px;
  text-shadow: 3px 3px 3px black;
  font-family: "monospace";
  color: #d11f31;
}
pre {
  font-size: calc(16px);
}
  .install-container .formdiv {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .terminal {
   text-align: left;
   color: white;
   font-family: monospace;
    z-index: 9999;
    background: rgba(0, 0,0, 1);
    backdrop-filter: blur(20px);
    box-shadow: 0 0 20px black;
    width: 100%;
    height: 100%;
 }
  .install-container input {
    padding: 10px 15px;
    border: none;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.2);
    color: black;
    font-size: 1rem;
  }
  .install-container input:focus {
    outline: 3px solid black;
  }
  .install-container input:hover {
    background-color: #f1f1e1e1
  }
  .install-container button {
    padding: 12px;
    background: black;
    color: white;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    font-weight: bold;
    transition: background 0.3s ease;
    
  }
  
  .install-container button:hover {
    background: #161c24;
  }
  
  p {
    display: inline;
  }

  .install {
    background-color: rgba(0,0,0,0);
    border: solid 1px #ef819d;
    border-radius: 0px; 
    height:auto;
  }
  
  @media screen and (min-width: 600px) {
    .install {
      background-color: rgba(0,0,0,0);
      border: solid 1px #ef819d;
      border-radius: 0px; 
      height:50px;
    }
  }
  .icons {
    display: flex;
    flex-direction: row;
    height: 20%;    
  }

  .windows-icon-link {

    position: relative;
    /* margin-top: 2a0px; */
    margin-right: 10px;
    left: calc(50% - 95px);
  }

  .windows-icon {
    position: relative;
    display: flex;
    flex-direction: row;
    color: white;
  }

  .windows-icon:hover {
    color: #faa0a7;
  }


`, "",{"version":3,"sources":["webpack://./src/InstallPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,mCAAmC;IACnC,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;;;EAGA;MACI,uBAAuB;MACvB,YAAY;MACZ,aAAa;MACb,iBAAiB;MACjB,kBAAkB;MAClB,uBAAuB;MACvB,YAAY;MACZ,aAAa;MACb,YAAY;MACZ,8BAA8B;MAC9B,2BAA2B;MAC3B,mBAAmB;MACnB,0BAA0B;MAC1B,kBAAkB;MAClB,YAAY;MACZ,sBAAsB;MACtB,QAAQ;IACV;EACF;IACE;MACE,uBAAuB;MACvB,YAAY;MACZ,aAAa;MACb,iBAAiB;MACjB,kBAAkB;MAClB,uBAAuB;MACvB,aAAa;MACb,aAAa;MACb,YAAY;MACZ,8BAA8B;MAC9B,2BAA2B;MAC3B,mBAAmB;MACnB,0BAA0B;MAC1B,kBAAkB;MAClB,YAAY;MACZ,sBAAsB;MACtB,QAAQ;IACV;EACF;EACA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;AACF;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;EACA;GACC,gBAAgB;GAChB,YAAY;GACZ,sBAAsB;IACrB,aAAa;IACb,2BAA2B;IAC3B,2BAA2B;IAC3B,0BAA0B;IAC1B,WAAW;IACX,YAAY;CACf;EACC;IACE,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,oCAAoC;IACpC,YAAY;IACZ,eAAe;EACjB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE;EACF;EACA;IACE,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gCAAgC;;EAElC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,+BAA+B;IAC/B,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE;MACE,+BAA+B;MAC/B,yBAAyB;MACzB,kBAAkB;MAClB,WAAW;IACb;EACF;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;;EAEA;;IAEE,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,cAAc;EAChB","sourcesContent":[".install-page {\n    display: flex;\n    height: 100vh;\n    background:white;\n    overflow: hidden;\n    font-family: 'Segoe UI', sans-serif;\n    color: white;\n    position: relative;\n  }\n  \n  .canvas-side {\n    width: 0%;\n    height: 100%;\n  }\n  .submit {\n    background: black;\n  }\n\n  \n  .install-container {\n      left: calc(50% - 200px);\n      color: black;\n      padding: 40px;\n      padding-left:30px;\n      padding-right:30px;\n      width: min(100vw,600px);\n      height: 100%;\n      z-index: 9999;\n      margin: auto;\n      background: rgba(0, 0, 0, 0.1);\n      backdrop-filter: blur(80px);\n      border-radius: 20px;\n      box-shadow: 0 0 20px black;\n      text-align: center;\n      display:flex;\n      flex-direction: column;\n      gap: 0px;\n    }\n  @media screen and (min-width: 600px) {\n    .install-container {\n      left: calc(50% - 200px);\n      color: black;\n      padding: 40px;\n      padding-left:30px;\n      padding-right:30px;\n      width: min(100vw,600px);\n      height: 350px;\n      z-index: 9999;\n      margin: auto;\n      background: rgba(0, 0, 0, 0.1);\n      backdrop-filter: blur(80px);\n      border-radius: 20px;\n      box-shadow: 0 0 20px black;\n      text-align: center;\n      display:flex;\n      flex-direction: column;\n      gap: 0px;\n    }\n  }\n  .install-container h2 {\n    margin-bottom: 30px;\n  }\n  \n  .install-container form {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n  }\nh3,pre {\n  margin-bottom:0px;\n  text-shadow: 3px 3px 3px black;\n  font-family: \"monospace\";\n  color: #d11f31;\n}\npre {\n  font-size: calc(16px);\n}\n  .install-container .formdiv {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n  }\n  .terminal {\n   text-align: left;\n   color: white;\n   font-family: monospace;\n    z-index: 9999;\n    background: rgba(0, 0,0, 1);\n    backdrop-filter: blur(20px);\n    box-shadow: 0 0 20px black;\n    width: 100%;\n    height: 100%;\n }\n  .install-container input {\n    padding: 10px 15px;\n    border: none;\n    border-radius: 10px;\n    background: rgba(255, 255, 255, 0.2);\n    color: black;\n    font-size: 1rem;\n  }\n  .install-container input:focus {\n    outline: 3px solid black;\n  }\n  .install-container input:hover {\n    background-color: #f1f1e1e1\n  }\n  .install-container button {\n    padding: 12px;\n    background: black;\n    color: white;\n    border: none;\n    border-radius: 10px;\n    cursor: pointer;\n    font-weight: bold;\n    transition: background 0.3s ease;\n    \n  }\n  \n  .install-container button:hover {\n    background: #161c24;\n  }\n  \n  p {\n    display: inline;\n  }\n\n  .install {\n    background-color: rgba(0,0,0,0);\n    border: solid 1px #ef819d;\n    border-radius: 0px; \n    height:auto;\n  }\n  \n  @media screen and (min-width: 600px) {\n    .install {\n      background-color: rgba(0,0,0,0);\n      border: solid 1px #ef819d;\n      border-radius: 0px; \n      height:50px;\n    }\n  }\n  .icons {\n    display: flex;\n    flex-direction: row;\n    height: 20%;    \n  }\n\n  .windows-icon-link {\n\n    position: relative;\n    /* margin-top: 2a0px; */\n    margin-right: 10px;\n    left: calc(50% - 95px);\n  }\n\n  .windows-icon {\n    position: relative;\n    display: flex;\n    flex-direction: row;\n    color: white;\n  }\n\n  .windows-icon:hover {\n    color: #faa0a7;\n  }\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
